// @flow

export const LANGUAGE_PORTUGUESE = 'pt';
export const LANGUAGE_SPANISH = 'es';
export const LANGUAGE_ENGLISH = 'en';
export const LANGUAGE_ARABIC = 'ar';
export const LANGUAGE_TURKISH = 'tr';
export const LANGUAGE_INDONESIAN = 'id';
export const LANGUAGE_THAI = 'th';
export const LANGUAGE_MALAY = 'ms';

export const ALL_SUPPORTED_LANGUAGES = [
  LANGUAGE_PORTUGUESE,
  LANGUAGE_SPANISH,
  LANGUAGE_ENGLISH,
  LANGUAGE_ARABIC,
  LANGUAGE_TURKISH,
  LANGUAGE_INDONESIAN,
  LANGUAGE_THAI,
  LANGUAGE_MALAY,
];

export const LANGUAGE_LABEL_ENGLISH = 'English | English';
export const LANGUAGE_LABEL_SPANISH = 'Spanish | Español';
export const LANGUAGE_LABEL_ARABIC = 'Arabic | عربي';
export const LANGUAGE_LABEL_PORTUGUESE = 'Portuguese | Português';
export const LANGUAGE_LABEL_TURKISH = 'Turkish | Türkçe';
export const LANGUAGE_LABEL_INDONESIAN = 'Indonesian | Bahasa Indonesia';
export const LANGUAGE_LABEL_THAI = 'Thai | ไทย';
export const LANGUAGE_LABEL_MALAY = 'Malay | Bahasa Melayu';

export type Language = { language: string, code: string };

export const LANGUAGES_BY_COUNTRY: { [key: string]: Language[] } = {
  br: [
    { language: LANGUAGE_LABEL_PORTUGUESE, code: LANGUAGE_PORTUGUESE },
  ],
  jm: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  ar: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  bo: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  cl: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  co: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  ec: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  mx: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  pe: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  uy: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  us: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  py: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  cr: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  gt: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  sv: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  pa: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  do: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  za: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  ke: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  ng: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  tz: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  in: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  ph: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  ug: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  zm: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  eg: [
    { language: LANGUAGE_LABEL_ARABIC, code: LANGUAGE_ARABIC },
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  gh: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  th: [
    { language: LANGUAGE_LABEL_THAI, code: LANGUAGE_THAI },
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  id: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
    { language: LANGUAGE_LABEL_INDONESIAN, code: LANGUAGE_INDONESIAN },
  ],
  tr: [
    { language: LANGUAGE_LABEL_TURKISH, code: LANGUAGE_TURKISH },
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  my: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
    { language: LANGUAGE_LABEL_MALAY, code: LANGUAGE_MALAY },
  ],
  ci: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  sn: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
};

export const LANGUAGE_BY_COUNTRY = {
  br: LANGUAGE_PORTUGUESE,
  ar: LANGUAGE_SPANISH,
  bo: LANGUAGE_SPANISH,
  cl: LANGUAGE_SPANISH,
  co: LANGUAGE_SPANISH,
  ec: LANGUAGE_SPANISH,
  mx: LANGUAGE_SPANISH,
  pe: LANGUAGE_SPANISH,
  uy: LANGUAGE_SPANISH,
  cr: LANGUAGE_SPANISH,
  py: LANGUAGE_SPANISH,
  pa: LANGUAGE_SPANISH,
  sv: LANGUAGE_SPANISH,
  gt: LANGUAGE_SPANISH,
  do: LANGUAGE_SPANISH,
  za: LANGUAGE_ENGLISH,
  ke: LANGUAGE_ENGLISH,
  ng: LANGUAGE_ENGLISH,
  in: LANGUAGE_ENGLISH,
  ph: LANGUAGE_ENGLISH,
  tz: LANGUAGE_ENGLISH,
  ug: LANGUAGE_ENGLISH,
  zm: LANGUAGE_ENGLISH,
  eg: LANGUAGE_ARABIC,
  gh: LANGUAGE_ENGLISH,
  id: LANGUAGE_ENGLISH,
  jm: LANGUAGE_ENGLISH,
  th: LANGUAGE_THAI,
  tr: LANGUAGE_TURKISH,
  my: LANGUAGE_ENGLISH,
  ci: LANGUAGE_ENGLISH,
  sn: LANGUAGE_ENGLISH,
};
